<template>
  <el-dialog
    :title="`${this.form.id ? '编辑' : '新增'}机构`"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="() => handleClose(false)"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="机构名称" required>
        <el-input
          v-model="form.name"
          placeholder="请输入机构名称"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构图片" required>
        <div class="img-control">
          <div class="img-box" v-if="form.img">
            <img :src="form.img" alt="封面图片" />
            <span class="clear-img" @click="handleClearImg">X</span>
          </div>
          <Upload ref="uploadRef" :text="'，图片尺寸为270px*104px'" v-model="form.img" />
        </div>
      </el-form-item>
      <el-form-item label="排序号">
        <el-row type="flex" align="middle">
          <el-input
            v-model="form.sortNum"
            placeholder="请输入排序号"
            maxlength="50"
          />&emsp;
          <el-tooltip effect="dark" content="前端展示按照排序号由大到小顺序排列">
            <i class="form-item-icon el-icon-question" />
          </el-tooltip>
        </el-row>
      </el-form-item>
      <el-form-item label="链接地址">
        <el-input
          v-model="form.linkUrl"
          placeholder="请输入链接地址"
          maxlength="500"
        />
        <span class="form-item-tips">链接地址必须以http://或者https://开头</span>
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button class="search-but1" size="small" @click="handleClose(false, form.content)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as API from '../../api/veteran/index'
import Upload from './module/upload.vue'

export default {
  props: ['dialogTitle', 'handleClose', 'defaultData', 'typeId', 'close'],
  name: 'CooperateWrite',
  components: { Upload },
  data() {
    return {
      form: {
        ...this.defaultData
      }
    }
  },
  methods: {
    async handleSubmit() {
      const { dialogTitle, typeId, form } = this
      const { name, img, sortNum, linkUrl } = form
      if (!name || !img ) {
        this.$message.warning('请填写必填项，再继续保存')
        return
      }
      const r1 = /^[1-9]\d*$/
      if (sortNum && !r1.test(sortNum)) {
        this.$message.warning('请输入正整数排序号!')
        return
      }
      const r2 = /^(http|https):\/\/([\w.]+\/?)\S*/
      if (linkUrl && !r2.test(linkUrl)) {
        this.$message.warning('请输入正确链接地址!')
        return
      }
      try {
        const data = {
          type: typeId,
          ...form
        }
        const { code } = await API.veteranManage(data)
        if (code === 0) {
          this.$message.success('保存成功')
          this.close(dialogTitle === '新建合作机构' ? 'reset' : 'update')
        }
      } catch (error) {}
    },
    handleClearImg() {
      this.$set(this.form, 'img', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.text-red {
  color: red;
}
.img-control {
  display: flex;
  .img-box {
    position: relative;
    margin-right: 10px;
    > img {
      width: 360px;
      height: 180px;
    }
    .clear-img {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      border: 1px solid #333;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.write-footer {
  text-align: right;
}
</style>
